export enum ABTestMode {
  New = 0,
  Current,
  Past,
}
